<template>
  <div class="coaWrapper">
    <!-- <h3 class="mb-2">COA 관리</h3> -->
    <SetPopup ref="confirm" />
    <v-form lazy-validation ref="form">
      <div class="filter-box filter-box--row">
        <ul class="filter-list_free">
          <li style="width: 120px">
            <h4>Lot No</h4>
            <v-text-field outlined dense placeholder="" v-model="input.lotNo" :rules="[this.validSet.commonCodeHipen]" @keyup.enter="search"></v-text-field>
          </li>
          <li style="width: 120px">
            <h4>Code Grade</h4>
            <v-text-field outlined dense placeholder="" v-model="input.code" :rules="[this.validSet.commonCodeHipen]" @keyup.enter="search"></v-text-field>
          </li>
          <li style="width: 120px">
            <h4>수령업체명</h4>
            <v-text-field outlined dense placeholder="" v-model="input.pickpart" :rules="[this.validSet.company]" @keyup.enter="search"></v-text-field>
          </li>
          <li style="width: 120px">
            <h4>수령자</h4>
            <v-text-field outlined dense placeholder="" v-model="input.request_name" :rules="[this.validSet.name]" @keyup.enter="search"></v-text-field>
          </li>
          <li>
            <h4>요청일</h4>
            <div class="dp--row">
              <v-menu v-model="picker1" :close-on-content-click="false" :nudge-right="0" :nudge-top="20" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="input.from_request_date" placeholder="" append-icon="mdi-calendar" outlined dense readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker no-title @input="picker1 = false" v-model="input.from_request_date"></v-date-picker>
              </v-menu>
              <i class="ml-1 mr-1">~</i>
              <v-menu v-model="picker2" :close-on-content-click="false" :nudge-right="0" :nudge-top="20" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="input.to_request_date" placeholder="" append-icon="mdi-calendar" outlined dense readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker no-title @input="picker2 = false" v-model="input.to_request_date"></v-date-picker>
              </v-menu>
            </div>
          </li>
          <li>
            <h4>제조일</h4>
            <div class="dp--row">
              <v-menu v-model="picker3" :close-on-content-click="false" :nudge-right="0" :nudge-top="20" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="input.from_produce_date" placeholder="" append-icon="mdi-calendar" outlined dense readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker no-title @input="picker3 = false" v-model="input.from_produce_date"></v-date-picker>
              </v-menu>
              <i class="ml-1 mr-1">~</i>
              <v-menu v-model="picker4" :close-on-content-click="false" :nudge-right="0" :nudge-top="20" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="input.to_produce_date" placeholder="" append-icon="mdi-calendar" outlined dense readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker no-title @input="picker4 = false" v-model="input.to_produce_date"></v-date-picker>
              </v-menu>
            </div>
          </li>
          <li style="width: 120px">
            <h4>상태</h4>
            <div class="wrapperTop">
              <v-select :items="code.Q" v-model="input.stat_str" outlined id="work" />
            </div>
          </li>
        </ul>
        <div class="btn-box">
          <v-card-actions>
            <v-btn depressed outlined class="btn-reset" @click="reset">초기화</v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn depressed class="btn-search" @click="search">검색</v-btn>
          </v-card-actions>
        </div>
      </div>
    </v-form>
    <div v-if="!msdsMode" class="coa-action-row">
      <v-btn depressed outlined class="btn-reset" @click="manualSend('COA')" style="width: 143px"><v-icon left small>mdi-email-outline</v-icon>COA 수기발송</v-btn>
      <v-btn depressed outlined class="btn-reset" @click="manualSend('MSDS')" style="width: 143px"><v-icon left small>mdi-email-outline</v-icon>MSDS 수기발송</v-btn>
      <v-btn depressed outlined class="btn-reset" :disabled="!canWriteCoa" @click="enterGenMode('MSDS')" style="width: 143px"><v-icon left small>mdi-creation</v-icon>MSDS 자동생성</v-btn>
      <v-btn depressed outlined class="btn-reset" :disabled="!canWriteCoa" @click="enterGenMode('LOC')" style="width: 143px"><v-icon left small>mdi-creation</v-icon>LOC 자동생성</v-btn>
      <v-btn depressed class="btn-download" @click="exelDownload" style="width: 143px">엑셀 다운로드</v-btn>
    </div>
    <div v-else class="coa-msds-bar">
      <span class="coa-msds-bar__hint">체크박스로 여러 건 선택 후 자동생성을 실행하세요 · 검수 없이 즉시 발행됩니다</span>
      <div class="coa-msds-bar__actions">
        <v-btn depressed outlined class="btn-reset" @click="exitMsdsMode" style="width: 90px">취소</v-btn>
        <v-btn depressed class="btn-msds-generate" :disabled="selectedCount === 0" @click="onBulkGenerateClick"> <v-icon left small>mdi-auto-fix</v-icon>선택한 {{ selectedCount }}건 {{ genType }} 자동생성 </v-btn>
      </div>
    </div>
    <RealGrid :domName="grid" ref="grid" :settings="settings" @changePage="loadData" @dbClick="dbClick" @click="click" @checkChange="onCheckChange" />

    <!-- 발행 전 사전검증 요약: 차단(발행불가) 제외 + 기존 MSDS 대체 경고 -->
    <v-dialog v-model="confirmDialog" max-width="620" persistent>
      <v-card class="msds-confirm">
        <v-card-title class="msds-confirm__title">
          자동생성 확인
          <v-spacer />
          <v-btn icon @click="confirmDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="msds-confirm__body">
          <!-- 발행 불가(차단) -->
          <div v-if="blockedRows.length" class="msds-confirm__block">
            <div class="msds-confirm__block-head">
              <v-icon color="#c0392b" small>mdi-close-circle-outline</v-icon>
              발행 불가 {{ blockedRows.length }}건 — 아래 항목은 자동생성에서 제외됩니다
            </div>
            <div class="msds-confirm__block-list">
              <div v-for="row in blockedRows" :key="row.lotNo" class="msds-confirm__row">
                <span class="lot">{{ row.lotNo }}</span>
                <ul>
                  <li v-for="(b, i) in row.blocks" :key="i" v-html="b"></li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 기존 MSDS 대체 경고 -->
          <div v-if="overwriteRows.length" class="msds-confirm__warn">
            <v-icon color="#e0a800" class="msds-confirm__warn-icon">mdi-alert-outline</v-icon>
            <div style="flex: 1">
              <p class="mb-1">
                발행 가능 <b>{{ publishableRows.length }}건</b> 중 <b>{{ overwriteRows.length }}건</b>에 이미 {{ genType }}가 첨부되어 있습니다.
              </p>
              <p class="mb-0">자동생성을 진행하면 기존 문서가 새 버전으로 대체됩니다.</p>
              <div class="msds-confirm__lots mt-2">
                <ul>
                  <li v-for="lot in overwriteLots" :key="lot">{{ lot }}</li>
                </ul>
              </div>
            </div>
          </div>
          <p class="msds-confirm__ask">발행 가능 {{ publishableRows.length }}건을 자동생성하시겠습니까?</p>
        </v-card-text>
        <v-card-actions class="msds-confirm__actions">
          <v-spacer />
          <v-btn depressed outlined class="btn-reset" @click="confirmDialog = false" style="width: 90px">취소</v-btn>
          <v-btn depressed class="btn-msds-generate" :disabled="publishableRows.length === 0" @click="runBulkGenerate"> <v-icon left small>mdi-auto-fix</v-icon>발행 가능 {{ publishableRows.length }}건 자동생성 </v-btn>
          <div class="msds-confirm__right-space"></div>
        </v-card-actions>
        <div class="msds-confirm__bottom-space"></div>
      </v-card>
    </v-dialog>

    <!-- 자동생성 결과 요약: 성공/실패 + 발행 후 확인 경고 + 제외(발행불가) -->
    <v-dialog v-model="resultDialog" max-width="620">
      <v-card class="msds-confirm">
        <v-card-title class="msds-confirm__title">
          자동생성 결과
          <v-spacer />
          <v-btn icon @click="resultDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="msds-confirm__body">
          <p class="msds-result__summary">
            성공 <b class="ok">{{ resultOk.length }}</b
            >건 · 실패 <b class="fail">{{ resultFail.length }}</b
            >건<span v-if="resultBlocked.length">
              · 제외(발행불가) <b>{{ resultBlocked.length }}</b
              >건</span
            >
          </p>
          <!-- 발행 후 확인 경고 -->
          <div v-if="resultWarnings.length" class="msds-confirm__warn" style="display: block">
            <p class="mb-2"><v-icon color="#e0a800" small>mdi-alert-outline</v-icon> 발행 후 확인 필요</p>
            <div v-for="w in resultWarnings" :key="w.lotNo" class="msds-confirm__row">
              <span class="lot">{{ w.lotNo }}</span>
              <ul>
                <li v-for="(m, i) in w.warnings" :key="i">{{ m }}</li>
              </ul>
            </div>
          </div>
          <!-- 발행 실패 -->
          <div v-if="resultFail.length" class="msds-confirm__block">
            <div class="msds-confirm__block-head"><v-icon color="#c0392b" small>mdi-close-circle-outline</v-icon> 발행 실패</div>
            <div class="msds-confirm__block-list">
              <div v-for="f in resultFail" :key="f.lotNo" class="msds-confirm__row">
                <span class="lot">{{ f.lotNo }}</span>
                <ul>
                  <li>{{ f.msg }}</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 발행 불가로 제외 -->
          <div v-if="resultBlocked.length" class="msds-confirm__block">
            <div class="msds-confirm__block-head"><v-icon color="#c0392b" small>mdi-close-circle-outline</v-icon> 발행 불가로 제외됨</div>
            <div class="msds-confirm__block-list">
              <div v-for="b in resultBlocked" :key="b.lotNo" class="msds-confirm__row">
                <span class="lot">{{ b.lotNo }}</span>
                <ul>
                  <li v-for="(m, i) in b.blocks" :key="i" v-html="m"></li>
                </ul>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="msds-confirm__actions">
          <v-spacer />
          <v-btn depressed class="btn-msds-generate" @click="resultDialog = false" style="min-width: 90px">확인</v-btn>
          <div class="msds-confirm__right-space"></div>
        </v-card-actions>
        <div class="msds-confirm__bottom-space"></div>
      </v-card>
    </v-dialog>

    <!-- 검증/발행 진행 오버레이 -->
    <v-overlay :value="validating || generating" z-index="9999">
      <div class="text-center">
        <v-progress-circular indeterminate size="48" width="4" />
        <div class="mt-3" v-if="validating">발행 대상 검증 중... ({{ progressCurrent }}/{{ selectedTotal }})</div>
        <div class="mt-3" v-else>{{ genType }} 자동생성 중... ({{ progressCurrent }}/{{ selectedTotal }})</div>
      </div>
    </v-overlay>
  </div>
</template>
<script>
import validSet from '@/assets/valid';
import RealGrid from '@/components/RealGrid.vue';
import SetPopup from '@/components/SetPopup.vue';
// eslint-disable-next-line no-unused-vars
import { columns, fields, rows, height } from '@/assets/grid/coa';
import { coalist, coadetail, resultsList, coaUpdate, manualMailSend, msdsPublish, msdsValidate, locPublish, locValidate } from 'api/sample/sample';
import { getCoapdfFile, getMsdspdfFile, getReportFile2, downloadIssuedDoc } from 'api/file';
import _ from 'lodash';
import { mapMutations, mapState, mapGetters } from 'vuex';
export default {
  data() {
    return {
      isFetching: false,
      isDataLoaded: false,
      id: '',
      picker1: false,
      picker2: false,
      picker3: false,
      picker4: false,
      validSet,
      grid: 'cda',
      input: {
        lotNo: '',
        code: '',
        request_name: '',
        pickpart: '',
        pageSize: 100000,
        from_request_date: '',
        to_request_date: '',
        from_produce_date: '',
        to_produce_date: '',
        stat_str: '전체',
      },
      origin: [],
      items: [],
      // 문서 자동생성(다중선택) 모드 상태 — genType 으로 MSDS/LOC 구분
      msdsMode: false,
      genType: 'MSDS', // 'MSDS' | 'LOC'
      selectedCount: 0,
      confirmDialog: false,
      selectedTotal: 0,
      validating: false,
      generating: false,
      progressCurrent: 0,
      // 사전검증 결과: [{ lotNo, canPublish, blocks[], warnings[], hasDoc }]
      preflightRows: [],
      // 결과 요약
      resultDialog: false,
      resultOk: [],
      resultFail: [],
      resultWarnings: [],
      resultBlocked: [],
      settings: {
        columns,
        fields,
        rows: 8,
        height: 650,
        errorMessage: '내역이 존재하지 않습니다',
        radio: true,
      },
    };
  },
  watch: {
    param: {
      deep: true,
      handler: function () {
        this.currentPage = 1;
      },
    },
  },
  methods: {
    ...mapMutations('popup', ['SET_POPUP']),
    ...mapMutations('member', ['SET_USER_INFO']),
    valid() {
      return this.$refs.form.validate();
    },
    async exelDownload() {
      const idx = this.$refs.grid.getCheckedRowIdxRadio();
      if (idx !== undefined && !isNaN(idx)) {
        let row = this.origin[idx];
        // 안되면 row에 lotNo 맞는지 확인해보기
        // eslint-disable-next-line no-self-assign
        row.lotNo = row.lotNo;
        await resultsList(row).then(async res => {
          const dt = res.data.data;

          await coaUpdate({
            idx: row.idx,
            memberId: this.id,
            lotNo: row.lotNo,
            excelDown: 'Y',
            results: dt.items,
          });
          await coadetail(row).then(res => {
            row = res.data.data;
            if (row.coaexcel_path) {
              getReportFile2(row.idx, row.lotNo, row.coaexcel_path);
            } else if (!row.coaexcel_path) {
              this.openPopup('COA 엑셀파일이 존재하지 않습니다');
            }
          });
        });
      } else {
        this.openPopup('다운로드할 행 선택해주세요');
      }
    },
    openPopup(text, closable, cb) {
      this.SET_POPUP({
        title: '알림',
        // height: 150,
        width: 300,
        text,
        closable,
      });
      this.$refs.confirm.openPopup(cb);
    },
    async search(v) {
      if (!this.valid()) return;
      if (this.isFetching) return;
      this.isFetching = true;

      try {
        if (_.isNumber(v)) {
          this.currentPage = v;
        }
        const res = await coalist({
          ...this.input,
          currentPage: this.currentPage,
        });
        this.isDataLoaded = false;

        const response = res.data;

        console.log(res.data, 'data');
        const items = response.data.items;
        this.items = response.data.items;
        const page = response.data.params;
        let filteredItems = items;

        if (this.input.from_request_date) {
          const fromDate = new Date(this.input.from_request_date);
          filteredItems = filteredItems.filter(item => new Date(item.request_date) >= fromDate);
        }
        if (this.input.to_request_date) {
          const toDate = new Date(this.input.to_request_date);
          filteredItems = filteredItems.filter(item => new Date(item.request_date) <= toDate);
        }
        if (this.input.from_produce_date) {
          const fromDate = new Date(this.input.from_produce_date);
          filteredItems = filteredItems.filter(item => new Date(item.produce_date) >= fromDate);
        }
        if (this.input.to_produce_date) {
          const toDate = new Date(this.input.to_produce_date);
          filteredItems = filteredItems.filter(item => new Date(item.produce_date) <= toDate);
        }
        if (this.input.stat_str == '완료') {
          const stat = this.input.stat_str;
          filteredItems = filteredItems.filter(item => item.stat_str == stat);
        }
        if (this.input.stat_str == '대기') {
          const stat = '대기';
          filteredItems = filteredItems.filter(item => item.stat_str == stat);
        }
        if (this.input.pickpart) {
          const pickpart = this.input.pickpart;
          filteredItems = filteredItems.filter(item => {
            if (item.pickpart === undefined) {
              return false;
            }
            return item.pickpart.includes(pickpart);
          });
        }

        this.$refs.grid.loadData(filteredItems, ['reg_dt', 'delivery_date']);
        this.$refs.grid.setPage(page);
        this.origin = filteredItems;
        if (this.msdsMode) this.selectedCount = 0; // 재조회 시 체크 초기화됨
      } catch (err) {
        this.error = err.message;
      } finally {
        this.isFetching = false;
      }
    },
    reset() {
      this.input = {
        lotNo: '',
        code: '',
        request_name: '',
        pickpart: '',
        pageSize: 100000,
        from_request_date: '',
        to_request_date: '',
        from_produce_date: '',
        to_produce_date: '',
      };
    },
    loadData(v) {
      this.search(v);
    },
    // 문서 자동생성 모드 진입: 체크바를 checkbox(다중선택)로 전환하고 안내 배너 노출. type=MSDS|LOC
    enterGenMode(type) {
      this.genType = type;
      this.msdsMode = true;
      this.selectedCount = 0;
      this.preflightRows = [];
      this.$refs.grid.clearAllChecks();
      this.$refs.grid.setCheckBarExclusive(false);
      this.$refs.grid.setCheckedRowHighlight(true); // 체크행 연한 초록(#eaf6ee) 하이라이트
    },
    // 모드 해제: radio(단일선택)로 복귀하고 체크 초기화
    exitMsdsMode() {
      this.msdsMode = false;
      this.selectedCount = 0;
      this.preflightRows = [];
      this.$refs.grid.setCheckedRowHighlight(false);
      this.$refs.grid.clearAllChecks();
      this.$refs.grid.setCheckBarExclusive(true);
    },
    // 체크박스 변경 시 선택 건수 갱신
    onCheckChange() {
      this.selectedCount = this.$refs.grid.getCheckedRow().length;
    },
    // 이미 해당 문서가 첨부/발행된 lot 인가.
    // MSDS: 수기 업로드 msdspdf_path 또는 자동생성 issued_document / LOC: 자동발행 issued_document 만(양산업로드 슬롯 없음)
    hasDoc(row) {
      if (this.genType === 'LOC') {
        return !!row.loc_issued_id;
      }
      const hasPath = !!row.msdspdf_path && row.msdspdf_path.split(',').some(p => p.trim() !== '');
      return hasPath || !!row.msds_issued_id;
    },
    // 자동생성 실행 클릭: 선택분을 먼저 사전검증(차단/경고) → 차단·대체 있으면 요약 모달, 없으면 즉시 발행
    async onBulkGenerateClick() {
      const checked = this.$refs.grid.getCheckedRow(); // [{ idx, data }]
      if (!checked.length) {
        this.openPopup('생성할 행을 선택해주세요', false);
        return;
      }
      const rows = checked.map(c => c.data);
      this.selectedTotal = rows.length;
      this.progressCurrent = 0;
      this.validating = true;
      const validateFn = this.genType === 'LOC' ? locValidate : msdsValidate;
      try {
        this.preflightRows = await Promise.all(
          rows.map(async row => {
            try {
              const res = await validateFn(row.lotNo);
              const d = (res.data && res.data.data) || {};
              this.progressCurrent += 1;
              return {
                lotNo: row.lotNo,
                canPublish: d.canPublish === true,
                blocks: d.blocks || [],
                warnings: d.warnings || [],
                hasDoc: this.hasDoc(row),
              };
            } catch (e) {
              this.progressCurrent += 1;
              return {
                lotNo: row.lotNo,
                canPublish: false,
                blocks: ['[자동발행 실패] 검증 중 오류가 발생했습니다. 관리자에게 문의해 주세요.'],
                warnings: [],
                hasDoc: this.hasDoc(row),
              };
            }
          }),
        );
      } finally {
        this.validating = false;
      }
      // 차단·대체 없으면 확인 없이 즉시 발행, 있으면 요약 모달
      if (this.blockedRows.length === 0 && this.overwriteRows.length === 0) {
        this.runBulkGenerate();
      } else {
        this.confirmDialog = true;
      }
    },
    // 발행 가능분만 순차 발행(검수 없이 즉시). 탭은 열지 않고 결과 요약 모달로 표시.
    async runBulkGenerate() {
      this.confirmDialog = false;
      if (this.generating) return;
      const targets = this.publishableRows.slice(); // 발행 가능분만
      // 차단 목록은 exit 전에 캡처(요약에 '제외됨'으로 표시)
      const blocked = this.blockedRows.map(r => ({ lotNo: r.lotNo, blocks: r.blocks }));
      if (!targets.length) {
        this.exitMsdsMode();
        this.resultOk = [];
        this.resultFail = [];
        this.resultWarnings = [];
        this.resultBlocked = blocked;
        this.resultDialog = true;
        return;
      }

      this.generating = true;
      this.selectedTotal = targets.length;
      this.progressCurrent = 0;
      const publishFn = this.genType === 'LOC' ? locPublish : msdsPublish;
      const ok = [];
      const fail = [];
      const warns = [];
      for (const r of targets) {
        this.progressCurrent += 1;
        try {
          await publishFn(r.lotNo, this.id);
          ok.push(r.lotNo);
          if (r.warnings && r.warnings.length) warns.push({ lotNo: r.lotNo, warnings: r.warnings });
        } catch (error) {
          let msg = '발행에 실패했습니다.';
          try {
            // blob 응답 에러 → 서버가 보낸 차단/실패 사유 텍스트
            if (error.response && error.response.data && typeof error.response.data.text === 'function') {
              msg = await error.response.data.text();
            }
          } catch (e) {
            /* noop */
          }
          fail.push({ lotNo: r.lotNo, msg });
        }
      }
      this.generating = false;
      this.exitMsdsMode();
      await this.search(); // 연결문서 변경 반영

      this.resultOk = ok;
      this.resultFail = fail;
      this.resultWarnings = warns;
      this.resultBlocked = blocked;
      this.resultDialog = true;
    },
    async manualSend(type) {
      // 그리드에서 실제 선택된 행 데이터를 직접 읽는다(필터/정렬로 this.items 인덱스가 어긋나 다른 lot을 집는 문제 방지)
      const checked = this.$refs.grid.getCheckedRow(); // [{ idx, data }]
      if (!checked.length) {
        this.openPopup('발송할 행을 선택해주세요', false);
        return;
      }
      const rowData = checked[0].data;

      // 필수값 체크: 파일 존재 여부 확인 (콤마로 구분된 경로 중 유효한 파일이 있는지 체크)
      if (type === 'COA') {
        const hasCoa = rowData.coapdf_path && rowData.coapdf_path.split(',').some(path => path.trim() !== '');
        if (!hasCoa) {
          this.openPopup('COA 파일이 업로드되지 않았습니다.', false);
          return;
        }
      } else if (type === 'MSDS') {
        const hasMsds = rowData.msdspdf_path && rowData.msdspdf_path.split(',').some(path => path.trim() !== '');
        if (!hasMsds) {
          this.openPopup('MSDS 파일이 업로드되지 않았습니다.', false);
          return;
        }
      }

      this.openPopup(`[${type}] 메일을 수기 발송하시겠습니까?`, true, async () => {
        try {
          const res = await manualMailSend({
            idx: rowData.idx,
            type: type,
          });
          console.log(res);
          if (res.status === 200) {
            this.openPopup(res.data.data.message, false);
            this.search(); // 상태 업데이트를 위해 재조회
          } else {
            // 백엔드에서 보낸 "MSDS 파일이 존재하지 않습니다." 등의 메시지를 출력
            const errorMsg = res.data.message || '메일 발송에 실패했습니다.';
            this.openPopup(errorMsg, false);
          }
        } catch (error) {
          console.error('Manual send error:', error);
          this.openPopup('서버 통신 중 오류가 발생했습니다.', false);
        }
      });
    },
    dbClick(data) {
      // 자동생성(다중선택) 모드에서는 더블클릭 상세이동 비활성화
      if (this.msdsMode) return;
      console.log(data, 'data');

      this.$emit(
        'dbClick',
        _.filter(this.origin, v => {
          return v.lotNo === data.lotNo;
        })[0],
      );
    },
    async click(data) {
      console.log(data, 'click data');
      if (data.cellType !== 'header') {
        try {
          const row = this.$refs.grid.getJsonRows();
          const coaPath = row[data.itemIndex].coapdf_path;
          const msdsPath = row[data.itemIndex].msdspdf_path;
          const locPath = row[data.itemIndex].locpdf_path;
          const idx = row[data.itemIndex].idx;

          if (data.fieldName == 'coapdf_path' && coaPath) {
            console.log('coa download start');
            let paths = coaPath.split(',');
            for (let path of paths) {
              if (path && path.trim() !== '') {
                path = path.trim();
                await getCoapdfFile(idx, path);
              }
            }
          } else if (data.fieldName == 'msdspdf_path' && msdsPath) {
            const issuedId = row[data.itemIndex].msds_issued_id;
            if (issuedId) {
              // 자동생성/발행 문서(issued_document) → 다운로드(저장)
              await downloadIssuedDoc(issuedId, msdsPath.split('/').pop());
            } else {
              // 기존 Coalist 수기 업로드 문서
              console.log('msds download start');
              let paths = msdsPath.split(',');
              for (let path of paths) {
                if (path && path.trim() !== '') {
                  path = path.trim();
                  await getMsdspdfFile(idx, path);
                }
              }
            }
          } else if (data.fieldName == 'locpdf_path' && locPath) {
            // LOC 은 항상 자동발행 문서(issued_document) → id 로 다운로드
            const issuedId = row[data.itemIndex].loc_issued_id;
            if (issuedId) {
              await downloadIssuedDoc(issuedId, locPath.split('/').pop());
            }
          }
        } catch (error) {
          console.log('error', error);
        }
      }
    },
    resizeGrid() {
      const totalHeight = window.innerHeight; // 현재 윈도우의 내부 높이
      const targetGrid = document.querySelector(`div#${this.grid}`);
      if (!targetGrid) return;
      let dynamicHeight = 360;
      if (this.showSearchOptions) {
        dynamicHeight += 70;
      }
      targetGrid.style.height = `${totalHeight - dynamicHeight}px`; // 그리드 컨테이너의 높이 조정
    },
  },
  mounted() {
    this.id = this.$store.state.member.userInfo.memberId;
    this.loadData();
    this.resizeGrid(); // 초기 로드 시 그리드 크기 조절
    window.addEventListener('resize', this.resizeGrid); // 윈도우 크기 변경 시 그리드 크기 조절
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeGrid);
  },
  computed: {
    ...mapState('common', ['code']),
    ...mapGetters('member', ['canWriteCoa']),
    // 사전검증 결과 분류
    blockedRows() {
      return this.preflightRows.filter(r => !r.canPublish);
    },
    publishableRows() {
      return this.preflightRows.filter(r => r.canPublish);
    },
    overwriteRows() {
      return this.publishableRows.filter(r => r.hasDoc);
    },
    overwriteLots() {
      return this.overwriteRows.map(r => r.lotNo);
    },
  },
  components: {
    RealGrid,
    SetPopup,
  },
};
</script>
<style lang="scss">
.coaWrapper {
  width: 98%;
  margin-left: auto;
  margin-right: auto;
}
.coa-action-row {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin: 8px 0;
}
/* MSDS 자동생성 모드 안내 배너 */
.coa-msds-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 8px 0;
  padding: 8px 12px;
  background: #f4f8f4;
  border: 1px solid #d6e4d6;
  border-radius: 6px;
}
.coa-msds-bar__hint {
  font-size: 13px;
  color: #5a6b5a;
}
.coa-msds-bar__actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.btn-msds-generate.v-btn {
  background: #4caf6a !important;
  color: #fff !important;
  font-weight: 600;
}
.btn-msds-generate.v-btn.v-btn--disabled {
  background: #bcd6c2 !important;
  color: #fff !important;
}
/* 자동생성 확인 모달 */
.msds-confirm__title {
  font-size: 18px;
  font-weight: 700;
  padding: 20px 24px 8px;
}
.msds-confirm__body {
  padding: 8px 24px 4px !important;
}
.msds-confirm__warn {
  display: flex;
  gap: 10px;
  background: #fff8e6;
  border-left: 4px solid #e0a800;
  border-radius: 4px;
  padding: 14px 16px;
  margin-bottom: 18px;
  font-size: 14px;
  color: #4a4a4a;
}
.msds-confirm__warn-icon {
  margin-top: 1px;
}
.msds-confirm__label {
  font-size: 13px;
  color: #888;
  margin-bottom: 6px;
}
.msds-confirm__lots {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  background: #fafafa;
  padding: 10px 16px;
  max-height: 160px;
  overflow-y: auto;
  margin-bottom: 16px;
}
.msds-confirm__lots ul {
  margin: 0;
  padding-left: 18px;
}
.msds-confirm__lots li {
  font-size: 14px;
  line-height: 1.7;
}
.msds-confirm__ask {
  font-size: 14px;
  margin-bottom: 4px;
}
.msds-confirm__actions {
  padding: 12px 20px 4px;
  gap: 10px;
}
/* Vuetify 기본 v-btn 좌우 마진 제거 → gap 으로 일정 간격 유지 */
.msds-confirm__actions .v-btn {
  margin: 0 !important;
}
/* Vuetify 의 .v-card__actions 패딩을 단일클래스로 못 이겨 버튼이 모서리에 잘림 →
   reason-modal 과 동일하게 카드 안 스페이서 div 로 오른쪽·아래 여백을 확실히 확보 */
.msds-confirm__right-space {
  width: 20px;
  flex: 0 0 auto;
}
.msds-confirm__bottom-space {
  height: 24px;
}
/* 차단(발행불가) 섹션 */
.msds-confirm__block {
  border: 1px solid #f0c9c4;
  background: #fdf3f2;
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 16px;
}
.msds-confirm__block-head {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  color: #c0392b;
  margin-bottom: 8px;
}
.msds-confirm__block-list {
  max-height: 220px;
  overflow-y: auto;
}
.msds-confirm__row {
  padding: 6px 0;
  border-top: 1px dashed #eadada;
}
.msds-confirm__row:first-child {
  border-top: none;
}
.msds-confirm__row .lot {
  font-weight: 700;
  font-size: 13px;
  color: #333;
}
.msds-confirm__row ul {
  margin: 4px 0 0;
  padding-left: 18px;
}
.msds-confirm__row li {
  font-size: 13px;
  line-height: 1.6;
  color: #555;
  white-space: pre-line; /* 백엔드 블록 문구의 "원인\n조치" 줄바꿈 표시 */
}
.msds-result__summary {
  font-size: 15px;
  margin-bottom: 16px;
}
.msds-result__summary .ok {
  color: #2e7d46;
}
.msds-result__summary .fail {
  color: #c0392b;
}
</style>
